import produce from 'immer';

const INITIAL_STATE = {
  data: [],
  loading: false
};

export default function partnership(state = INITIAL_STATE, action: any) {
  switch (action.type) {
    case '@partnership/LIST_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
      });

    case '@partnership/LIST_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.data = action.payload.list;
      });

    case '@partnership/LIST_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
      });

    default:
      return state;
  }
}
